import { render, staticRenderFns } from "./Certificado.vue?vue&type=template&id=21eeee73&scoped=true&lang=pug&"
import script from "./Certificado.vue?vue&type=script&lang=js&"
export * from "./Certificado.vue?vue&type=script&lang=js&"
import style0 from "./Certificado.styl?vue&type=style&index=0&id=21eeee73&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eeee73",
  null
  
)

export default component.exports